export const SET_ALL = 'participants/SET_ALL';
export const SET_BY_ID = 'participants/SET_BY_ID';
